import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as notificationsAPI from 'api/notifications';

const initalState = {
  pagination: {
    pageSize: 10,
    currentPage: 1,
    totalRecords: null,
    index: 1
  },
  data: [],
  unread: [],
  ui: {
    loading: false,
    msg: ''
  },
  status: 'init'
};

const getNotificationsState = (state) => state.reporting;

const getNotificationsData = createAsyncThunk('notifications/getNotificationsData', async ({ signal, ...params }, { rejectWithValue }) => {
  try {
    const res = await notificationsAPI.getNotifications(params, signal);
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
const getUnreadNotificationsData = createAsyncThunk('notifications/getUnreadNotifications', async ({ signal }) => {
  const res = await notificationsAPI.getUnreadNotifications(signal);
  return res.data?.data;
});
const markAsReadNotifications = createAsyncThunk('notifications/markAsReadNotifications', async ({ params, signal }) => {
  const res = await notificationsAPI.markAsReadNotifications(params, signal);
  return { ...params, ...res.data?.data };
});
const markAsUnReadNotifications = createAsyncThunk('notifications/markAsUnReadNotifications', async ({ params, signal }) => {
  const res = await notificationsAPI.markAsUnReadNotifications(params, signal);
  return { ...params, ...res.data?.data };
});
const deletedNotifications = createAsyncThunk('notifications/deletedNotifications', async ({ params, signal }) => {
  const res = await notificationsAPI.deletedNotifications(params, signal);
  return { ...params, ...res.data?.data };
});
// const scorecardFeatureWiseGraphData = createAsyncThunk('notifications/scorecardFeatureWiseGraph', async ({ filterResult }) => {
//   const res = await notificationsAPI.scorecardFeatureWiseGraph(filterResult);
//   return res.data?.data;
// });

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
    },
    setPaginationData: (state, action) => {
      state.pagination = {
        pageSize: action.payload.pageSize,
        index: action.payload.index
      };
    }
  },
  extraReducers: {
    [getNotificationsData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getNotificationsData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload.results;
      state.pagination.totalRecords = action.payload.count;
    },

    [getNotificationsData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getUnreadNotificationsData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getUnreadNotificationsData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.unread = action.payload;
    },

    [getUnreadNotificationsData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [markAsReadNotifications.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [markAsReadNotifications.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const { notification_ids } = action.payload;
      if (notification_ids) {
        state.data.map((_el, index) => {
          if (notification_ids.includes(_el.id)) {
            state.data[index].is_read = true;
          }
        });
      }
      // state.data = action.payload.results;
      console.log('mark as read', action.payload);
    },

    [markAsReadNotifications.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [markAsUnReadNotifications.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [markAsUnReadNotifications.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const { notification_ids } = action.payload;
      if (notification_ids) {
        state.data.map((_el, index) => {
          if (notification_ids.includes(_el.id)) {
            state.data[index].is_read = false;
          }
        });
      }
      // state.data = action.payload.results;
      console.log('mark as unread', action.payload);
    },

    [markAsUnReadNotifications.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [deletedNotifications.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [deletedNotifications.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const { notification_ids } = action.payload;
      if (notification_ids) {
        state.data = state.data.filter((_el) => !notification_ids.includes(_el.id));
      }
      // state.data = action.payload.results;
      console.log('mark as unread', action.payload);
    },

    [deletedNotifications.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

export const { setCurrentPage, setPageSize, setPaginationData } = notificationsSlice.actions;

export default notificationsSlice.reducer;

export {
  getNotificationsState,
  getUnreadNotificationsData,
  deletedNotifications,
  markAsUnReadNotifications,
  markAsReadNotifications,
  getNotificationsData
};
